import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'Title',
  props: {
    text: {},
    textColor: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("h3", {
    class: "text-balance font-semibold tracking-tight",
    style: _normalizeStyle({ color: _ctx.textColor })
  }, _toDisplayString(_ctx.text), 5))
}
}

})